import { actions, types } from './requests'
export const GETCOMMANDLIST_TYPES = {
    ...types('GETCOMMANDLIST'),
}
export const GETCOMMANDLIST_ACTIONS = {
    ...actions('GETCOMMANDLIST'),
}